import styled from "@emotion/styled";
import {Card, Grid, SpeedDial, SpeedDialAction, Tooltip, tooltipClasses} from "@mui/material";
import {getExerciseStem, getSentencenr} from "../utils/utils";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import HelpIcon from "@mui/icons-material/Help";
import AssistantIcon from '@mui/icons-material/Assistant';
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import CodeIcon from "@mui/icons-material/Code";
import React from "react";
import * as PropTypes from "prop-types";
import ComponentFactory from "../exercisecomponents/ComponentFactory";

export function SingleExerciseComponent(props) {
    const HtmlTooltip = styled(
        ({className, ...props}) =>
            (
                <Tooltip {...props} classes={{popper: className}}/>
            )
    )
    (
        ({theme}) =>
            (
                {
                    [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: '#f5f5f9',
                        color: 'rgba(0, 0, 0, 0.87)',
                        // fontSize: theme.typography.pxToRem(12),
                        maxWidth: 'none',
                        border: '1px solid #dadde9',
                    },
                }
            )
    );

    return <div style={{backgroundColor: "#fff", padding: "0.4em"}}>
        <Card elevation={3}
              sx={{padding: "0 1em 1em 1em", margin: "0", backgroundColor: "#fff",}}
              square={true}>
            <Grid container columns={30}>
                <Grid item xs={1}>
                    {/*<HtmlTooltip title={<pre>{JSON.stringify(props.value, null, 2)}</pre>}>*/}
                        <p><b>{props.index}.</b></p>
                    {/*</HtmlTooltip>*/}
                </Grid>
                <Grid item xs={29}>
                    <div style={{backgroundColor: "#fff"}}>
                        {getExerciseStem(props.value)}
                        <ComponentFactory exercise={props.value}
                                          feedbackMode={props.feedbackMode}
                                          toggleDrawJSON={props.onToggleDrawJSON}
                                          toggleDrawHilfe={props.onToggleDrawHilfe}
                                          toggleDrawLesetext={props.onToggleDrawLesetext}
                                          lesetext={props.lesetext}/>
                        {getSentencenr(props.value)}

                        {/*<SpeedDial*/}
                        {/*    ariaLabel="SpeedDial controlled open example"*/}
                        {/*    FabProps={{size: "small", color: "primary"}}*/}
                        {/*    sx={{position: "relative", left: "0em", top: "0em"}}*/}
                        {/*    direction="left"*/}
                        {/*    icon={<MoreHorizIcon/>}*/}
                        {/*    // onClose={handleSpeedDialClose}*/}
                        {/*    // onOpen={handleSpeedDialOpen}*/}
                        {/*    // open={openSpeedDial}*/}
                        {/*>*/}
                        {/*    <SpeedDialAction*/}
                        {/*        onClick={props.onToggleDrawLesetext}*/}
                        {/*        title="Lesetext"*/}
                        {/*        icon={<TextSnippetIcon/>}*/}
                        {/*    />*/}
                        {/*    <SpeedDialAction*/}
                        {/*        onClick={props.onToggleDrawJSON}*/}
                        {/*        title="JSON"*/}
                        {/*        icon={<CodeIcon/>}*/}

                        {/*    />*/}
                        {/*    <SpeedDialAction*/}
                        {/*        onClick={props.onToggleDrawHilfe}*/}
                        {/*        title="Hilfe"*/}
                        {/*        icon={<HelpIcon/>}*/}

                        {/*    />*/}
                        {/*    <SpeedDialAction*/}
                        {/*        onClick={props.onToggleFeedbackmode}*/}
                        {/*        title={(props.feedbackMode === "mode_feedback") ? "normal mode" : "feedback mode"}*/}
                        {/*        icon={<AssistantIcon/>}*/}

                        {/*    />*/}
                        {/*</SpeedDial>*/}
                    </div>
                </Grid>
            </Grid>
        </Card>
    </div>;
}

SingleExerciseComponent.propTypes = {
    value: PropTypes.any,
    index: PropTypes.any,
    lesetext: PropTypes.any,
    onToggleDrawLesetext: PropTypes.func,
    onToggleDrawJSON: PropTypes.func,
    onToggleDrawHilfe: PropTypes.func
};
